import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
// utils
import { fToNow } from 'src/utils/format-time';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
// components


// ----------------------------------------------------------------------

export default function NotificationItem({ notification  , setSelectedNotificationId , onClose }) {
  const router = useRouter();
  const handleMarkAsRead = () => {
    if(!notification.is_read){
       setSelectedNotificationId(notification?._id);
     } else {
       setSelectedNotificationId(null);
    }
    handleNavigation();
  }

  const handleNavigation = () => {
    if(notification?.type === 'job') {
      if(notification?.title?.includes("Deleted")){
          router.push(paths?.dashboard?.jobs?.root);
          return;
      }
      router.push(`${paths?.dashboard?.jobs?.root}/${notification?.object?._id}`);
    }

    if(notification?.type === 'quote') {
      router.push(`${paths?.dashboard?.jobs?.root}/${notification?.object?.job || notification?.object?.job?._id}`);
    }

    if(notification?.type === 'contact_support') {
      router.push(paths?.superAdminDashboard?.requests?.contactSupport);
    }

    if(notification?.type === 'contact_us') {
      router.push(paths?.superAdminDashboard?.requests?.contactUs);
    }

    if(notification?.type === 'invoice') {
      router.push(`${paths?.dashboard?.invoices?.root}/${notification?.object?._id}`);
    }
    onClose();
  }
  const renderAvatar = (
    <ListItemAvatar>
      {notification?.icon && notification.icon !== "noimg.png" ? (
        <Avatar src={notification?.icon} sx={{ bgcolor: 'background.neutral' }} />
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            bgcolor: 'background.neutral',
          }}
        >
          <Box
            component="img"
            src={"/assets/confirmed.svg"}
            sx={{ width: 40, height: 40 }}
          />
        </Stack>

      )}
    </ListItemAvatar>
  );

  // const renderText = (
  //   <ListItemText
  //     disableTypography
  //     primary={reader(notification.message)}
  //     secondary={
  //       <Stack
  //         direction="row"
  //         alignItems="center"
  //         sx={{ typography: 'caption', color: 'text.disabled' }}
  //         divider={
  //           <Box
  //             sx={{
  //               width: 2,
  //               height: 2,
  //               bgcolor: 'currentColor',
  //               mx: 0.5,
  //               borderRadius: '50%',
  //             }}
  //           />
  //         }
  //       >
  //         {fToNow(notification.createdAt)}
  //         {notification.type?.slice(0, 1).toUpperCase() + notification.type?.slice(1).replace(/_/g, ' ')}
  //       </Stack>
  //     }
  //   />
  // );

  const renderText = (
    <ListItemText
      disableTypography
      primary={
        <Stack spacing={0.3}>
          {/* Title — bold, prominent */}
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              fontSize: '0.8125rem',
              lineHeight: 1.4,
              color: notification.is_read ? 'text.secondary' : 'text.primary',
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
              {notification.title}
          </Typography>
  
          {/* Message — description style, muted, 2-line clamp */}
          <Typography
            variant="body2"
            sx={{
              fontSize: '0.75rem',
              lineHeight: 1.55,
              color: 'text.secondary',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {reader(notification.message)}
          </Typography>
        </Stack>
      }
      secondary={
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          sx={{ mt: 0.6 }}
          divider={
            <Box
              sx={{
                width: 3,
                height: 3,
                borderRadius: '50%',
                bgcolor: 'text.disabled',
                flexShrink: 0,
              }}
            />
          }
        >
          <Typography
            variant="caption"
            sx={{ fontSize: '0.6875rem', color: 'text.disabled', whiteSpace: 'nowrap' }}
          >
            {fToNow(notification.createdAt)}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontSize: '0.6875rem',
              color: notification.is_read ? 'text.disabled' : 'primary.main',
              fontWeight: notification.is_read ? 400 : 500,
              textTransform: 'capitalize',
              whiteSpace: 'nowrap',
            }}
          >
            {notification.type?.replace(/_/g, ' ')}
          </Typography>
        </Stack>
      }
    />
  );
  const renderUnReadBadge = !notification.is_read && (
    <Box
      sx={{
        top: 26,
        width: 8,
        height: 8,
        right: 20,
        borderRadius: '50%',
        bgcolor: 'info.main',
        position: 'absolute',
      }}
    />
  );

  // const friendAction = (
  //   <Stack spacing={1} direction="row" sx={{ mt: 1.5 }}>
  //     <Button size="small" variant="contained">
  //       Accept
  //     </Button>
  //     <Button size="small" variant="outlined">
  //       Decline
  //     </Button>
  //   </Stack>
  // );

  // const projectAction = (
  //   <Stack alignItems="flex-start">
  //     <Box
  //       sx={{
  //         p: 1.5,
  //         my: 1.5,
  //         borderRadius: 1.5,
  //         color: 'text.secondary',
  //         bgcolor: 'background.neutral',
  //       }}
  //     >
  //       {reader(
  //         `<p><strong>@Jaydon Frankie</strong> feedback by asking questions or just leave a note of appreciation.</p>`
  //       )}
  //     </Box>

  //     <Button size="small" variant="contained">
  //       Reply
  //     </Button>
  //   </Stack>
  // );

  // const fileAction = (
  //   <Stack
  //     spacing={1}
  //     direction="row"
  //     sx={{
  //       pl: 1,
  //       p: 1.5,
  //       mt: 1.5,
  //       borderRadius: 1.5,
  //       bgcolor: 'background.neutral',
  //     }}
  //   >
  //     <FileThumbnail
  //       file="http://localhost:8080/httpsdesign-suriname-2015.mp3"
  //       sx={{ width: 40, height: 40 }}
  //     />

  //     <Stack spacing={1} direction={{ xs: 'column', sm: 'row' }} flexGrow={1} sx={{ minWidth: 0 }}>
  //       <ListItemText
  //         disableTypography
  //         primary={
  //           <Typography variant="subtitle2" component="div" sx={{ color: 'text.secondary' }} noWrap>
  //             design-suriname-2015.mp3
  //           </Typography>
  //         }
  //         secondary={
  //           <Stack
  //             direction="row"
  //             alignItems="center"
  //             sx={{ typography: 'caption', color: 'text.disabled' }}
  //             divider={
  //               <Box
  //                 sx={{
  //                   mx: 0.5,
  //                   width: 2,
  //                   height: 2,
  //                   borderRadius: '50%',
  //                   bgcolor: 'currentColor',
  //                 }}
  //               />
  //             }
  //           >
  //             <span>2.3 GB</span>
  //             <span>30 min ago</span>
  //           </Stack>
  //         }
  //       />

  //       <Button size="small" variant="outlined">
  //         Download
  //       </Button>
  //     </Stack>
  //   </Stack>
  // );

  // const tagsAction = (
  //   <Stack direction="row" spacing={0.75} flexWrap="wrap" sx={{ mt: 1.5 }}>
  //     <Label variant="outlined" color="info">
  //       Design
  //     </Label>
  //     <Label variant="outlined" color="warning">
  //       Dashboard
  //     </Label>
  //     <Label variant="outlined">Design system</Label>
  //   </Stack>
  // );

  // const paymentAction = (
  //   <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
  //     <Button size="small" variant="contained">
  //       Pay
  //     </Button>
  //     <Button size="small" variant="outlined">
  //       Decline
  //     </Button>
  //   </Stack>
  // );

  return (
    <ListItemButton
      disableRipple
      onClick={()=>handleMarkAsRead()}
      sx={{
        p: 2.5,
        alignItems: 'center',
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,

      }}
    >
      {renderUnReadBadge}

      {renderAvatar}

      <Stack sx={{ flexGrow: 1 }}>
        {renderText}
        {/* {notification.type === 'friend' && friendAction} */}
        {/* {notification.type === 'project' && projectAction} */}
        {/* {notification.type === 'file' && fileAction} */}
        {/* {notification.type === 'tags' && tagsAction} */}
        {/* {notification.type === 'payment' && paymentAction} */}
      </Stack>
    </ListItemButton>
  );
}

NotificationItem.propTypes = {
  notification: PropTypes.object,
};

// ----------------------------------------------------------------------

function reader(data) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: data }}
      sx={{
        pr:1,
        mb: 0.5,
        '& p': { typography: 'body2', m: 0 },
        '& a': { color: 'inherit', textDecoration: 'none' },
        '& strong': { typography: 'subtitle2' },
      }}
    />
  );
}
